import { useContext, React } from 'react';
import BPHeader from './BPHeader';
import BPFooter from './BPFooter';
import { BusinessPartnerContext } from './BusinessPartnerCard';
import BPSection from './BPSection';
import { SECTIONS } from './utils';

const BPCompanyDetails = () => {
  const { localBPData, isEditing, handleOnChange, dropdownValues, errors } = useContext(BusinessPartnerContext);

  return (
    <>
      <section className="bp-companydetails">
        <BPHeader />
        <BPSection
          sections={SECTIONS.BPCompanyDetails}
          isEditing={isEditing}
          localBPData={localBPData}
          dropdownValues={dropdownValues}
          errors={errors}
          handleOnChange={handleOnChange}
        />
      </section>
      <BPFooter />
    </>
  );
};

export default BPCompanyDetails;
